import { getOrCreateFeatureFlag } from '../../../config/FeatureFlag';
import type { FeatureFlagName } from '../../../config/FeatureFlagNames';
import { useState } from 'react';

export function useFeatureFlag<T = any>(key: FeatureFlagName, defaultValue: T): T {
	const [state, setState] = useState<T>(defaultValue);
	const [isInitialized, setIsInitialized] = useState<boolean>(false);

	const { client } = getOrCreateFeatureFlag();
	if (client && !isInitialized) {
		client
			.waitForInitialization(5)
			.then((): void => {
				const value = getOrCreateFeatureFlag().getFeatureValue<T>(key, defaultValue);
				setState(value);
				setIsInitialized(true);
			})
			.catch((err): void => console.error('error initializing LDClient', err));
	}

	return state;
}
